<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFolderDownload } from "@mdi/js";
export default {
  name: "MdiFolderDownload",
  data() {
    return {
      svgPath: mdiFolderDownload,
    };
  },
};
</script>
